<div
  #reportContainer
  class="report-preview-area"
>
  @for (artifact of extractedArtifacts; track artifact.artifactId) {
    <div
      class="report-artifact-object"
      [ngClass]="{'report-artifact-object-grid': !isViewWithFullImage() && isLeftAdjustedImages()}"
    >
      @if (artifact.images) {
        <div
          [ngClass]="{'report-artifact-object-fields-image-full': isViewWithFullImage(),
                    'report-artifact-object-fields-left': !isViewWithFullImage() && !isLeftAdjustedImages(),
                    'report-artifact-object-fields-right': !isViewWithFullImage() && isLeftAdjustedImages()}"
        >
          <div class="report-artifact-field-image">
            <div class="report-artifact-field-image-box">
              @if (isViewWithFullImage()) {
                <img
                  [src]="imageUrls.get(artifact.thumbnailImage.image_id)"
                  class="report-artifact-field-image-img"
                  [alt]="artifact.artifact_name ?? 'thumbnail image'"
                />
              }
              @else if (artifact.thumbnailImage) {
                <app-thumbnail
                  [item]="artifact.thumbnailImage"
                  [stylingClass]="'report-artifact-field-image-img'"
                ></app-thumbnail>
              }
            </div>
          </div>
        </div>
      }


      <div class="report-artifact-content">
        <h1>
          {{ artifact.artifactName }}
        </h1>

        @for (section of artifact.sections; track section.id) {
          @if (isShowSectionTitles()) {
            <h2>
              {{section.title | translate}}
            </h2>
          }

          @for (field of section.fields; track field.key; let isEven = $even; let isFirst = $first) {
            <div
              [ngClass]="{'report-artifact-grid': !(isHidePrompts() && isViewPromptSeparateLines()),
                          'report-artifact-grid-one-col': isHidePrompts() || (!isHidePrompts() && isViewPromptSeparateLines()),
                          'report-artifact-grid-even': !field.hasHeader1Or2 && isEven,
                          'report-artifact-grid-first': isFirst}"
            >
              @if (!isHidePrompts()) {
                <div class="report-artifact-field-title">
                  <span>
                    {{ field.key }}
                  </span>
                </div>
              }

              <div
                class="report-artifact-field-values"
                [ngClass]="{'report-artifact-values-table' : field.hasHeader1Or2}"
              >
                @for (value of field.value; track $index; let isLast = $last) {
                  <ul
                    class="report-artifact-value-list"
                    [ngClass]="{'report-artifact-value-list-table' : field.hasHeader1Or2}"
                  >
                    @if (value.headersLevel1) {
                      <li class="report-artifact-value-header-level-1">
                        {{ value.headersLevel1 }}
                      </li>
                    }

                    @if (value?.headersLevel2 || value?.labels || value?.values) {
                      <li [class.report-artifact-value-list-last]="isLast">
                        <div [ngClass]="{'report-artifact-field-values-grid': !(isHidePrompts() && isViewPromptSeparateLines()),
                                         'report-artifact-field-values-grid-one-col': !isHidePrompts() && isViewPromptSeparateLines()}"
                        >
                          @if (value?.headersLevel2 || value?.labels) {
                            <div class="report-artifact-field-values-grid-left">
                              @if (value.headersLevel2) {
                                <strong>
                                  {{ value.headersLevel2 }}
                                </strong>
                              }
                              @if (value.labels) {
                                <strong>
                                  <span
                                    class="report-artifact-value-label"
                                    [innerHTML]="value.labels"
                                  ></span>
                                </strong>
                              }
                            </div>
                          }

                          <div
                            class="report-artifact-field-values-grid-right"
                            [innerHTML]="value.values"
                          ></div>
                        </div>
                      </li>
                    }
                  </ul>
                }
              </div>
            </div>
          }
        }
      </div>
      </div>
  }

  <div id="endOfReport"></div>
</div>
